import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ThemeModule } from '../theme/theme.module';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { AvatarComponent } from './avatar/avatar.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CenterViewComponent } from './center-view/center-view.component';
import { ClickOutsideDirective } from './clickOutside.directive';
import { ContentEditorComponent } from './content-editor/content-editor.component';
import { ContentViewComponent } from './content-view/content-view.component';
import { EmojiImagePipe } from './emoji-image.pipe';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { InputFormComponent } from './input-form/input-form.component';
import { LoadingShadeComponent } from './loading-shade/loading-shade.component';
import { LoadingComponent } from './loading/loading.component';
import { MessageComponent } from './message/message.component';
import { NotifyPopupComponent } from './notify-popup/notify-popup.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ScrollTrackerDirective } from './scroll-tracker.directive';
import { OptionComponent } from './select/option/option.component';
import { SelectComponent } from './select/select/select.component';
import { StripTagsPipe } from './strip-tags.pipe';
import { SuccessMessageComponent } from './success-message/success-message.component';
import { TagMenuComponent } from './tag-menu/tag-menu.component';
import { TextInputComponent } from './text-input/text-input.component';
import { TimeAgoPipe } from './time-ago.pipe';
import { TitleService } from './title.service';
import { UserEconomyComponent } from './user-economy/user-economy.component';
import { VerticalMenuComponent } from './vertical-menu/vertical-menu.component';

@NgModule({
  declarations: [
    AlertDialogComponent,
    BreadcrumbComponent,
    CenterViewComponent,
    ClickOutsideDirective,
    ContentEditorComponent,
    ContentViewComponent,
    ErrorMessageComponent,
    InputFormComponent,
    LoadingComponent,
    LoadingShadeComponent,
    MessageComponent,
    OptionComponent,
    PaginationComponent,
    SelectComponent,
    TextInputComponent,
    StripTagsPipe,
    TimeAgoPipe,
    ScrollTrackerDirective,
    SuccessMessageComponent,
    AvatarComponent,
    UserEconomyComponent,
    NotifyPopupComponent,
    EmojiImagePipe,
    TagMenuComponent,
    VerticalMenuComponent
  ],
  exports: [
    AvatarComponent,
    BreadcrumbComponent,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTooltipModule,
    CenterViewComponent,
    ContentEditorComponent,
    ContentViewComponent,
    ErrorMessageComponent,
    InputFormComponent,
    LoadingComponent,
    LoadingShadeComponent,
    MessageComponent,
    OptionComponent,
    PaginationComponent,
    ScrollTrackerDirective,
    SelectComponent,
    SuccessMessageComponent,
    TextInputComponent,
    StripTagsPipe,
    TimeAgoPipe,
    EmojiImagePipe,
    UserEconomyComponent,
    TagMenuComponent,
    VerticalMenuComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTooltipModule,
    RouterModule,
    ThemeModule
  ],
  providers: [TitleService, TimeAgoPipe, provideHttpClient(withInterceptorsFromDi())]
})
export class SharedModule {}
